import getColor from "@insite/mobius/utilities/getColor";
import { orderHistoryTableStyles } from "@waytek/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

orderHistoryTableStyles.container = {
    ...orderHistoryTableStyles.container,
    css: css`
        border-bottom: 2px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
        margin-bottom: 28px;
        overflow: auto;
        position: relative;
    `,
};

orderHistoryTableStyles.tableHeader = {
    ...orderHistoryTableStyles.tableHeader,
    css: css`
        svg {
            color: white;
        }

        button {
            width: auto;
        }
    `,
};

orderHistoryTableStyles.headerClickable = {
    ...orderHistoryTableStyles.headerClickable,
    css: css`
        &&& {
            width: auto;
        }
    `,
};

orderHistoryTableStyles.orderTotalCells = {
    ...orderHistoryTableStyles.orderTotalCells,
    alignX: "left",
};

orderHistoryTableStyles.reorderButton = {
    ...orderHistoryTableStyles.reorderButton,
    sizeVariant: "small",
};

orderHistoryTableStyles.noResultsText = {
    ...orderHistoryTableStyles.noResultsText,
    variant: "p",
    css: css`
        font-size: 24px;
        font-weight: 700;
        text-transform: none;
    `,
};
